const qtySelectCombo = {
  combos: document.querySelectorAll('[data-qty-select-combo]') as NodeListOf<HTMLElement>,

  init() {
    this.bindCombos();
    this.bindOutsideClose();
  },

  bindCombos() {
    this.combos.forEach((combo) => {
      if (combo.dataset.qtyInit === '1') return;
      combo.dataset.qtyInit = '1';

      const form = combo.closest('form') as HTMLFormElement | null;
      if (!form) return;

      const select = combo.querySelector('.qty-select-combo__select') as HTMLSelectElement | null;
      const input = combo.querySelector('.qty-select-combo__input') as HTMLInputElement | null;
      if (!select || !input) return;

      const neto =
        (form.querySelector('.js-neto-qty') as HTMLInputElement | null) ??
        (form.querySelector('input[id^="qty["][name^="qty["]') as HTMLInputElement | null);
      if (!neto) return;

   
      neto.style.display = 'none';

      const min = this.toInt(neto.getAttribute('min')) ?? 1;
      const max = this.toInt(neto.getAttribute('max')) ?? 9999;

      input.min = String(min);
      input.max = String(max);

      const clamp = (n: number) => Math.min(Math.max(n, min), max);
      const syncNeto = (n: number) => {
        const v = clamp(n);
        neto.value = String(v);
        neto.dispatchEvent(new Event('input', { bubbles: true }));
        neto.dispatchEvent(new Event('change', { bubbles: true }));
        return v;
      };

      const openChevron = () => combo.classList.add('is-open');
      const closeChevron = () => combo.classList.remove('is-open');

      const showInput = () => {
        combo.classList.add('is-custom', 'no-chev');
        input.hidden = false;
        input.disabled = false;
        input.placeholder = 'Enter\nQty';
        input.value = '';
      };

      const hideInput = () => {
        combo.classList.remove('is-custom', 'no-chev');
        input.hidden = true;
        input.disabled = true;
        input.placeholder = '';
      };

      // ---- init from neto ----
      const initial = syncNeto(this.toInt(neto.value) ?? min);
      select.value = initial >= 1 && initial <= 9 ? String(initial) : 'custom';
      hideInput();
      closeChevron();


      select.addEventListener('pointerdown', openChevron);
      select.addEventListener('click', openChevron);

  
      select.addEventListener('change', () => {
        window.setTimeout(closeChevron, 0);

        if (select.value === 'custom') {
          showInput();
          return;
        }

        const n = this.toInt(select.value);
        if (n == null) return;

        syncNeto(n);
        hideInput();
      });


      input.addEventListener('input', () => {
        const n = this.toInt(input.value);
        if (n == null) return;
        input.value = String(syncNeto(n));
      });


      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          hideInput();
        }
      });
    });
  },


  bindOutsideClose() {
    document.addEventListener(
      'pointerdown',
      (e) => {
        const t = e.target as Node | null;
        if (!t) return;

        const insideAny = Array.from(this.combos).some((c) => c.contains(t));
        if (insideAny) return;

        this.combos.forEach((c) => c.classList.remove('is-open'));
      },
      { capture: true }
    );
  },

  toInt(val: string | null) {
    if (!val || val.trim() === '') return null;
    const n = parseInt(val, 10);
    return Number.isNaN(n) ? null : n;
  }
};

export default qtySelectCombo;
